// src/components/Certifications.js
import React from 'react';
import { CERTIFICATIONS } from '../Constants';

const Certifications = () => {
  return (
    <section id="certifications" className="p-8 flex flex-col justify-center items-center bg-gradient-to-r from-blue-400 to-purple-600">
      <h2 className="text-3xl font-bold text-center mb-6">Certifications</h2>
      <ul className="max-w-md p-8 bg-gradient-to-r from-blue-400 shadow-lg to-purple-600mx-auto">
        {CERTIFICATIONS.map((cert, index) => (
          <li key={index} className="mb-4">
            <h3 className="text-xl font-semibold">{cert.title}</h3>
            <p className="text-gray-600">{cert.issuer}</p>
            <a
              href={cert.link}
              className="text-blue-800 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Certification
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Certifications;
